import React from 'react';
import {
  useParams,
} from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Typography,
} from "@mui/material";

export default function DisplayReportByReportName() {
  let params = useParams();
  const { report_name } = params;

  const { allReportsLink } = useSelector((state) => state?.allReportsDetails);
  const reportURL = allReportsLink[report_name];

  return (
    <div style={{ width: "100%" }}>
      {reportURL ? (
        <div style={{ position: "relative", width: "100%", height: "calc(100vh - 180px)", overflow: "hidden" }}>
          <iframe
            title={report_name}
            src={reportURL ?? ""}
            style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: 0 }}
            frameBorder="0"
            allowFullScreen
          />
        </div>
      ) : (
        <Typography variant="h4" align="center" sx={{ mt: "22%" }}>
          No Report Found
        </Typography>
      )}
    </div>
  )
};
